/**
 * Prefer a vertical board when the play area is taller than it is wide.
 * Falls back to viewport size when a container is not measured yet.
 */
export function shouldRenderBoardVertically(
  width?: number,
  height?: number
): boolean {
  const w = width && width > 0 ? width : typeof window !== 'undefined' ? window.innerWidth : 768;
  const h = height && height > 0 ? height : typeof window !== 'undefined' ? window.innerHeight : 1024;
  // Tall/narrow → vertical board (4×8 visual). Wide/short → horizontal (8×4).
  return h >= w;
}

/** Logical board is 8×4; after vertical flip it is 4×8. Pick orientation that maximizes cell size. */
export function preferVerticalForBoardBox(
  boxWidth: number,
  boxHeight: number,
  cols = 8,
  rows = 4
): boolean {
  if (boxWidth <= 0 || boxHeight <= 0) {
    return shouldRenderBoardVertically(boxWidth, boxHeight);
  }
  const cellIfHorizontal = Math.min(boxWidth / cols, boxHeight / rows);
  const cellIfVertical = Math.min(boxWidth / rows, boxHeight / cols);
  return cellIfVertical >= cellIfHorizontal;
}
